import { render, staticRenderFns } from "./CustomPCheckbox.vue?vue&type=template&id=00c2ae03&scoped=true&"
import script from "./CustomPCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomPCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CustomPCheckbox.vue?vue&type=style&index=0&id=00c2ae03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c2ae03",
  null
  
)

export default component.exports